import { useEffect, useState } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { fetchCuestionarioById } from '../../api/cuestionariosApi';

const parseRespuestas = (value) => {
  if (!value) return {};
  if (typeof value === 'string') {
    try { return JSON.parse(value); } catch (_e) { return {}; }
  }
  return typeof value === 'object' ? value : {};
};

const unwrapEntity = (payload) => payload?.data ?? payload;

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
};

const EMPTY_SCALE = { pre: '', intermedia: '', final: '' };

export const useCuestionarioTesisTorresViewer = ({ idCuestionario, paciente }) => {
  const [patientInfo, setPatientInfo] = useState({ nombre: '', apellidos: '', createdAt: '' });
  const [fields, setFields] = useState({
    dolorCronico: '',
    intensidadDolor: '',
    minimental: '',
    escalaDolor: { ...EMPTY_SCALE },
    kinesiofobia: { ...EMPTY_SCALE },
    catastrofismo: { ...EMPTY_SCALE },
    gradacionDolorCronico: { ...EMPTY_SCALE },
    sf12: { ...EMPTY_SCALE },
  });
  const [openGood, setOpenGood] = useState(false);

  useEffect(() => {
    if (!idCuestionario || !paciente) return;
    fetchCuestionarioById(idCuestionario, paciente)
      .then((rawData) => {
        const data = unwrapEntity(rawData);
        const r = parseRespuestas(data.respuestas);
        setPatientInfo({
          nombre: data?.paciente?.firstname || '',
          apellidos: data?.paciente?.lastname || '',
          createdAt: formatDate(data.createdAt),
        });
        setFields({
          dolorCronico: r.dolorCronico || '',
          intensidadDolor: r.intensidadDolor || '',
          minimental: r.minimental || '',
          escalaDolor: r.escalaDolor || { ...EMPTY_SCALE },
          kinesiofobia: r.kinesiofobia || { ...EMPTY_SCALE },
          catastrofismo: r.catastrofismo || { ...EMPTY_SCALE },
          gradacionDolorCronico: r.gradacionDolorCronico || { ...EMPTY_SCALE },
          sf12: r.sf12 || { ...EMPTY_SCALE },
        });
      })
      .catch(console.error);
  }, [idCuestionario, paciente]);

  const handleExportPDF = () => {
    const input = document.getElementById('pdf-content');
    html2canvas(input, {
      scale: 2,
      backgroundColor: null,
      useCORS: true,
      ignoreElements: (el) => el.tagName === 'BUTTON',
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`cuestionario_tesis_${patientInfo.nombre}${patientInfo.apellidos}_${patientInfo.createdAt}.pdf`);
      })
      .catch(console.error);
  };

  return {
    patientInfo,
    fields,
    openGood,
    setOpenGood,
    handleExportPDF,
  };
};
